/**
 * These constants are used to express the different layers of the application.
 * They map to z-index.
 *
 * These layers are intended to be a deterministic order for elements that float
 * above the rest of the application. These kinds of elements should normally be
 * attached near the DOM's body element, either in the root div of the app or
 * whichever element is the parent for the normal app surface and floating elements.
 *
 * We're leaving a lot of space between these to ensure we have room to mutate.
 *
 * To use these, apply their values as the z-index of whatever element you want to lift up.
 * If possible, don't add/subtract from them. In many cases, DOM order will take care of the
 * stacking i.e. a modal w/ z-index 600 that renders a Flyout w/ z-index 600 will be in
 * the correct order since the Flyout is added after the Modal.
 */
export const layers = {
  /**
   * This is for the left/right panels. The rails and the panels should both be contained
   * within this layer, and the proper sub-z-indexes should be appled to ensure the panels
   * slide behind the rails i.e. 200 on the rail/panel container, 2 on the rail itself, 1
   * on the panel itself.
   */
  panel: 100,
  /**
   * This is for flyouts that operate just above the surface layer.
   */
  flyout: 490,
  /**
   * For modals and any of their floating children.
   */
  modal: 600,
  /**
   * For toasts, which sit above modals but beneath transient entities like tooltips.
   */
  toast: 700,
  /**
   * Tooltips should show above everything, regardless of the target's layering.
   */
  tooltip: 900
};
//# sourceMappingURL=layers.js.map